import {
  RP_TPA_DAILY_MODEL_LIST,
  RP_TPA_DAILY_PAGINATION,
  RP_TPA_DAILY_SEARCH,
} from "./actionType";

import moment from 'moment';

const initialState = {
  modelDeviceList: [],
  modelSearch: { SUMMARYREPORT_DATE: new Date(), BALANCESHIPPER_NAME: "" }, //SUMMARYREPORT_DATE: moment(new Date().setDate(new Date().getDate() - 1)).format("YYYY-MM-DD")
  pagination: { sizePerPage: 100, page: 1 }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RP_TPA_DAILY_MODEL_LIST:
      return { ...state, modelDeviceList: action.payload };
    case RP_TPA_DAILY_SEARCH:
      return {
        ...state,
        modelSearch: action.payload,
      };
    case RP_TPA_DAILY_PAGINATION:
      return { ...state, pagination: { sizePerPage: action.payload.sizePerPage, page: action.payload.page } };
    default:
      return state;
  }
};
